module.exports = __webpack_public_path__ + "media/images/icons/visa_small-4fe8a875ef50da06b33c72e071275a51.svg";